import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBackendResponse, MoneyTransaction, MoneyTransactionSubmittedData } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpResponseHandleHelper } from '../http/http-response-handle-helper';

@Injectable({
  providedIn: 'root',
})
export class MoneyTransactionService {
  constructor(private http: HttpClient) {}

  public requestTAN(moneyTransactionData: MoneyTransaction): Observable<IBackendResponse<boolean>> {
    return HttpResponseHandleHelper.handleResponse(
      this.http.post<boolean>(`${environment.apihost}/api/moneytransaction/requesttan`, moneyTransactionData, {
        params: HttpResponseHandleHelper.skipGlobalHandler(),
      }),
    );
  }

  public createMoneyTransaction(submitData: MoneyTransactionSubmittedData): Observable<IBackendResponse<boolean>> {
    return HttpResponseHandleHelper.handleResponse(
      this.http.post<boolean>(`${environment.apihost}/api/moneytransaction`, submitData, {
        params: HttpResponseHandleHelper.skipGlobalHandler(),
      }),
    );
  }

  public validateMTData(moneyTransactionData: MoneyTransaction): Observable<IBackendResponse<boolean>> {
    return HttpResponseHandleHelper.handleResponse(
      this.http.post<boolean>(`${environment.apihost}/api/moneytransaction/validate`, moneyTransactionData, {
        params: HttpResponseHandleHelper.skipGlobalHandler(),
      }),
    );
  }

  public requestAppAuth(serial: string, moneyTransactionData: MoneyTransaction): Observable<IBackendResponse<string>> {
    return HttpResponseHandleHelper.handleResponse(
      this.http.post(
        `${environment.apihost}/api/moneytransaction/requestauth`,
        {
          moneyTx: moneyTransactionData,
          serialForAppAuth: serial,
        },
        {
          responseType: 'text',
          params: HttpResponseHandleHelper.skipGlobalHandler(),
        },
      ),
    );
  }
}
